import { safeDeepGet, safeDeepSet } from "iotera-base/json";

export function getPercentOf(percent, total) {
  return total * percent / 100;
}

export function getWidthColumnByPercent(percent, total, fallback = null) {
  const result = getPercentOf(percent, total - 20)
  if (!Number.isInteger(fallback)) {
    fallback = 100;
  }
  return result > 100 ? result : fallback;
}

export function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    return;
  }
  navigator.clipboard.writeText(text).then(function () {
    console.log('Async: Copying to clipboard was successful!');
  }, function (err) {
    console.error('Async: Could not copy text: ', err);
  });
}

export const dashedLineChartData = (data, key) => {
  let dataChart = [...data]
  for (var i in data) {
    let val = safeDeepGet(data[i], key)
    if (val === true || val === false) {
      val = `${val}`
      let keyVal = val
      safeDeepSet(dataChart[i], keyVal, val)
    }
    else {
      let keyVal = val
      safeDeepSet(dataChart[i], keyVal, val)
    }
  }
  return dataChart
}

export const solidLineChartData = (data, key) => {
  let dataChart = [...data]
  for (var i in data) {
    let val = safeDeepGet(data[i], key)
    if (val === true || val === false) {
      val = `${val}`
      dataChart[i][key] = val
    }
  }
  return dataChart
}

export const axisYCustom = (data, key) => {
  let dataY = []
  let axisY = []
  for (var i in data) {
    const y = safeDeepGet(data[i], key)
    if (y === true || y === false) y = `${y}`
    dataY.push(y)
  }
  dataY.sort()
  for (i in dataY) {
    if (dataY[i] !== dataY[i - 1]) {
      const y = dataY[i]
      axisY.push(y)
    }
  }
  return axisY
}

export const getChartType = (data, key) => {
  let type
  for (var i in data) {
    const dataKey = safeDeepGet(data[i], key)
    if (dataKey === true || dataKey === false) type = 'bool'
    else type = 'text'
  }
  return type
}

// function about responsive
export const setObjectData = (key, x, y, w, h, skeletonWidth, skeletonPosition, hasFocus, component, dataToShare) => {
  let rank = (y * 2) + x
  let objectData = {
    'key': key,
    'x': x,
    'y': y,
    'w': w,
    'h': h,
    'rank': rank,
    'skeletonWidth': skeletonWidth,
    'skeletonPosition': skeletonPosition,
    'hasFocus': hasFocus,
    'component': component,
    'dataToShare': dataToShare
  }
  return objectData
}

export const setOrderDataCard = dataCard => {
  return dataCard.sort((a, b) => a.rank - b.rank)
}

// end of function about responsive